// Application form on /ambassadors. Posts to the public apply endpoint on
// commerce-server; approval and account creation happen in the dashboard.
const RAW_API_BASE = import.meta.env.VITE_COMMERCE_API_URL || 'https://api.whistlerbusinesssolutions.com';
const API_BASE = /^https?:\/\//.test(RAW_API_BASE) ? RAW_API_BASE : `https://${RAW_API_BASE}`;

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ambassador-apply-form');
  if (!form) return;

  const kindSelect = document.getElementById('amb-kind');
  const orgFields = document.getElementById('amb-org-fields');
  const status = document.getElementById('amb-status');
  const submit = document.getElementById('amb-submit');

  const showStatus = (message, kind) => {
    status.textContent = message;
    status.classList.add('is-visible');
    status.classList.toggle('is-error', kind === 'error');
    status.classList.toggle('is-success', kind === 'success');
  };

  const syncOrgFields = () => {
    orgFields.hidden = kindSelect.value !== 'organization';
  };
  kindSelect.addEventListener('change', syncOrgFields);
  syncOrgFields();

  const params = new URLSearchParams(window.location.search);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    status.classList.remove('is-visible');

    const data = new FormData(form);
    const payload = {
      name: (data.get('name') || '').trim(),
      email: (data.get('email') || '').trim(),
      kind: data.get('kind') || 'creator',
      orgName: (data.get('orgName') || '').trim(),
      audience: (data.get('audience') || '').trim(),
      links: (data.get('links') || '').trim(),
      pitch: (data.get('pitch') || '').trim(),
      requestedCode: (data.get('requestedCode') || '').trim(),
      website: (data.get('website') || '').trim(), // honeypot
      agreedToTerms: data.get('agreedToTerms') === 'on',
      ref: params.get('ref') || undefined,
      utmSource: params.get('utm_source') || undefined,
    };

    if (!payload.name) return showStatus('Please tell us your name.', 'error');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) {
      return showStatus('Please enter a valid email address.', 'error');
    }
    if (!payload.agreedToTerms) {
      return showStatus('Please agree to the disclosure and content guidelines to continue.', 'error');
    }

    submit.disabled = true;
    submit.textContent = 'Sending…';

    try {
      const res = await fetch(`${API_BASE}/api/ambassadors/apply`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const body = await res.json().catch(() => ({}));

      if (!res.ok) {
        showStatus(body.error || 'Something went wrong. Please try again in a moment.', 'error');
        submit.disabled = false;
        submit.textContent = 'Submit application';
        return;
      }

      form.querySelectorAll('input, textarea, select, button').forEach((el) => {
        el.disabled = true;
      });
      showStatus(
        'Application received. We read every one — expect to hear back by email within a few days.',
        'success'
      );
      submit.textContent = 'Application sent';
    } catch (err) {
      console.error(err);
      showStatus('We could not reach the server. Please check your connection and try again.', 'error');
      submit.disabled = false;
      submit.textContent = 'Submit application';
    }
  });
});
